export const nomineeID = ["Aadhaar Card", "Pan Card"];
